import { createContext, useContext } from 'react';

export const ProductContext = createContext({
  product: null,
  selectedVariant: null,
  setSelectedVariant: () => undefined,
  selectedOptions: [],
  setSelectedOptions: () => undefined,
  selectedMedia: [],
  setSelectedMedia: () => undefined,
});

export function useProductContext() {
  const ctx = useContext(ProductContext);
  if (!ctx) {
    throw new Error('useProductContext must be used within <ProductProvider>');
  }
  return ctx;
}
